(() => {
  const ACTION_SELECTOR = "button, a, [role='button'], input[type='button'], input[type='submit']";
  const APP_SELECTOR = "es-button, [class*='easysell' i], [id*='easysell' i], [class*='es-button' i], [id*='es-button' i], iframe[src*='easysell' i], iframe[src*='tyslo' i]";
  const APP_ACTION_SELECTOR = "es-button, .es-button, iframe[src*='easysell' i], iframe[src*='tyslo' i]";
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toUpperCase();

  const setImportant = (element, styles) => {
    if (!element || !element.style) return;
    Object.entries(styles).forEach(([property, value]) => {
      element.style.setProperty(property, value, 'important');
    });
  };

  const lightDomNode = (element) => {
    const root = element.getRootNode();
    return root instanceof ShadowRoot && root.host ? root.host : element;
  };

  const appWrapper = (element, boundary) => {
    let node = lightDomNode(element);
    const marked = node.closest?.(APP_SELECTOR);
    if (marked && boundary.contains(marked)) node = marked;

    if (node === boundary || node.contains(boundary)) return null;
    return node;
  };

  const styleAction = (action, context) => {
    action.classList.add(context === 'cart' ? 'jd1-cart-cod-action' : 'jd1-pdp-cod-action');
    setImportant(action, {
      'box-sizing': 'border-box',
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      'width': '100%',
      'min-width': '0',
      'height': '60px',
      'min-height': '60px',
      'max-height': '60px',
      'margin': '0',
      'padding': '0 18px',
      'border-radius': '15px',
      'background': '#171717',
      'color': '#ffffff',
      'font-weight': '700',
      'text-transform': 'uppercase'
    });
  };

  const alignCartAction = (action) => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer || !drawer.contains(lightDomNode(action))) return;

    styleAction(action, 'cart');
    const footer = drawer.querySelector('.drawer__footer-bottom');
    const checkout = footer?.querySelector('.drawer__footer-buttons');
    if (!footer || !checkout) return;

    let wrapper = appWrapper(action, drawer);
    if (!wrapper) return;

    if (footer.contains(wrapper)) {
      while (wrapper.parentElement && wrapper.parentElement !== footer) {
        if (wrapper.parentElement === checkout) break;
        wrapper = wrapper.parentElement;
      }
    }

    if (wrapper === checkout || wrapper.contains(checkout)) return;
    wrapper.classList.add('jd1-cart-cod-wrap');
    setImportant(wrapper, { width: '100%', 'min-width': '0', height: '60px', 'min-height': '60px', 'max-height': '60px', margin: '0', padding: '0', 'border-radius': '15px', overflow: 'hidden' });

    if (wrapper.parentElement !== footer) {
      footer.insertBefore(wrapper, checkout);
    } else if (wrapper.nextElementSibling !== checkout) {
      footer.insertBefore(wrapper, checkout);
    }
  };

  const alignPdpAction = (action) => {
    const pdp = lightDomNode(action).closest?.('.jd1-standard-pdp');
    if (!pdp) return;

    styleAction(action, 'pdp');
    const formWrapper = pdp.querySelector('.product-form-wrapper');
    const productForm = formWrapper?.querySelector(':scope > .product-form');
    if (!formWrapper || !productForm) return;

    let wrapper = appWrapper(action, pdp);
    if (!wrapper || wrapper === productForm || wrapper.contains(productForm)) return;

    wrapper.classList.add('jd1-pdp-cod-wrap');
    setImportant(wrapper, { width: '100%', 'min-width': '0', margin: '0', padding: '0' });

    if (wrapper.parentElement !== formWrapper) {
      productForm.insertAdjacentElement('afterend', wrapper);
    } else if (productForm.nextElementSibling !== wrapper) {
      productForm.insertAdjacentElement('afterend', wrapper);
    }
    formWrapper.classList.add('jd1-has-cod');
  };

  const handleAction = (action) => {
    const label = normalize(action.value || action.textContent || action.getAttribute('aria-label'));
    if (!label.includes('CONTRA ENTREGA') && !action.matches?.(APP_ACTION_SELECTOR)) return;
    alignCartAction(action);
    alignPdpAction(action);
  };

  const scan = (root = document) => {
    root.querySelectorAll?.(`${ACTION_SELECTOR}, ${APP_ACTION_SELECTOR}`).forEach(handleAction);
    root.querySelectorAll?.('*').forEach((element) => {
      if (element.shadowRoot) scan(element.shadowRoot);
    });
  };

  let queued = false;
  const queueScan = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueScan, { once: true });
  } else {
    queueScan();
  }

  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', queueScan);
})();
